const contentStatusNumber = [
  'Ready to Implement',
  'Needs Correction',
  'Delegated',
  'Impediment',
  'Concluded',
];

export { contentStatusNumber };
